import { generatePath, useHistory } from 'react-router-dom'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
} from 'features/networkAi/hooks'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useState, useEffect } from 'react'
import ROUTES from 'app/routes'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { NetworkAIBackButton, NetworkAIBackIcon } from '../styles'
import {
  NetworkWLANsContainer,
  ListWLANsHeaderWrapper,
  WLANListTitle,
  ConfigureRadioButton,
  CreateWLANsButton,
} from './styles'
import NetworkRadioConfigModal from '../components/NetworkRadioConfigModal'
import { network } from 'features/networkAi/messages'
import WLANsList from './WLANsList'
import { WhiteBlock } from 'components/Layout'
import {
  mistOrganizationIdSelector,
  siteInfoFetchDataSelector,
} from 'features/networkAi/selectors'
import { fetchSiteInfoThunk } from 'features/networkAi/slice'
import { SpinnerCentered } from 'components/Loader'

function NetworkWLANs() {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const siteInfo = useAppSelector(siteInfoFetchDataSelector.data)
  const isLoading = useAppSelector(siteInfoFetchDataSelector.isFetching)

  const orgId = useAppSelector(mistOrganizationIdSelector)
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })

  const [isOpenRadioModal, setIsOpenRadioModal] = useState(false)

  useEffect(() => {
    siteId && dispatch(fetchSiteInfoThunk(siteId))
  }, [dispatch, siteId])

  const handleNavigateNetworkAIClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.root, {
      rootDomainId,
      jobId,
      homeId,
      siteId,
    })
    history.push(pathname)
  }

  const wlanId = 'new'

  const handleNavigateWlanEditClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.editCreateWLANs, {
      rootDomainId,
      jobId,
      homeId,
      siteId,
      wlanId,
    })
    history.push(pathname)
  }

  const handleRadioOpenClick = () => {
    setIsOpenRadioModal(true)
  }

  return (
    <>
      {isLoading ? (
        <SpinnerCentered mt="200px" />
      ) : (
        <>
          <NetworkRadioConfigModal
            isOpen={isOpenRadioModal}
            orgId={orgId}
            siteId={siteId}
            rfTemplateID={siteInfo?.rftemplate_id || ''}
            handleClose={() => setIsOpenRadioModal(false)}
          />
          <StyledFadeInWrapper>
            <NetworkWLANsContainer>
              <NetworkAIBackButton onClick={handleNavigateNetworkAIClick}>
                <NetworkAIBackIcon
                  src={makePublicUrl(`images/networkIcons/arrow-back.svg`)}
                />
                {formatMessage(network.backNetworkAI)}
              </NetworkAIBackButton>

              <ListWLANsHeaderWrapper>
                <WLANListTitle>{formatMessage(network.wlans)}</WLANListTitle>

                <ConfigureRadioButton
                  variant="secondary"
                  onClick={handleRadioOpenClick}
                >
                  {formatMessage(network.radioConfig)}
                </ConfigureRadioButton>

                <CreateWLANsButton
                  variant="primary"
                  onClick={handleNavigateWlanEditClick}
                >
                  {formatMessage(network.addWlan)}
                </CreateWLANsButton>
              </ListWLANsHeaderWrapper>

              <WhiteBlock>
                <WLANsList />
              </WhiteBlock>
            </NetworkWLANsContainer>
          </StyledFadeInWrapper>
        </>
      )}
    </>
  )
}

export default NetworkWLANs
